import ManagementContainer from './ManagementContainer';

export default ManagementContainer;
